import React, { useRef, useState, useEffect } from "react";
import {
  Form,
  Button,
  Card,
  Alert,
  Container,
  ListGroup,
  Modal,
} from "react-bootstrap";
import { useAuth } from "../contexts/AuthContext";
import { fires } from "../firebase";
import { useNavigate } from "react-router-dom";
import { isMobile } from "react-device-detect";

export default function CreateEditLinks() {
  const newLinkTitleRef = useRef();
  const newLinkURLRef = useRef();
  const passwordRef = useRef();
  const passwordConfirmRef = useRef();
  const { currentUser, logout } = useAuth();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [posts, setPosts] = useState([]);
  const [viewTypes, setViewTypes] = useState([]);
  const [views, setViews] = useState([]);
  const [gData, setGData] = useState([]);
  const [links, setLinks] = useState([]);

  const [show, setShow] = useState(false);

  const [modifyId, setModifyId] = useState(-1);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const maxW = isMobile ? "100%" : "60%";

  var uid = currentUser.uid;
  var cEmail = currentUser.email;
  var orgId = "";

  const routeToHome = () => {
    let path = "/";
    window.location.href = path;
  };

  const routeToLogout = () => {
    logout();
    let path = "/";
    window.location.href = path;
  };

  const isToday = (someDate) => {
    const today = new Date();
    return (
      someDate.getDate() == today.getDate() &&
      someDate.getMonth() == today.getMonth() &&
      someDate.getFullYear() == today.getFullYear()
    );
  };

  useEffect(() => {
    fires
      .collection("users")
      .doc(uid)
      .get()
      .then((snapshot) => {
        if (snapshot.exists) {
          const users = [];
          const userData = snapshot.data();
          orgId = userData.orgId;
          fires
            .collection("groups")
            .doc(orgId)
            .get()
            .then((snapshotB) => {
              if (snapshotB.exists) {
                var gData = [];
                var groupData = snapshotB.data();
                gData.push({ ...groupData, id: orgId });
                setGData(groupData);
                var links = [];
                if (groupData.contacts != null) {
                  links = groupData.contacts;
                  setLinks(links);
                }
              }
            });
        } else {
          //deleted
          posts.push({
            id: uid,
            error: "NotFound",
            error_message: "没有访问权限",
            error_code: 404,
          });
          setPosts(posts);
          document.title = "乐源 LETJOY";
          document.description = "开启你的海外生活";
          routeToLogout();
        }
      });
  }, []);

  function handleSubmit(e) {
    e.preventDefault();
    if (passwordRef.current.value !== passwordConfirmRef.current.value) {
      return setError("Passwords do not match");
    }

    const promises = [];
    setLoading(true);
    setError("");

    Promise.all(promises)
      .then(() => {
        navigate("/");
      })
      .catch(() => {
        setError("Failed to update account");
      })
      .finally(() => {
        setLoading(false);
      });
  }

  return (
    <>
      <Container
        className="d-flex justify-content-center"
        style={{ minHeight: "100vh" }}
      >
        <div
          className="w-100"
          style={{ maxWidth: maxW, marginTop: "25px", marginBottom: "25px" }}
        >
          {error && <Alert variant="danger">{error}</Alert>}
          <Card>
            <Card.Body className="align-items-center justify-content-center">
              <Card.Title className="text-center">添加和删除链接</Card.Title>
              <Card.Text
                className="text-center"
                style={{ marginTop: "10px", fontWeight: "bold" }}
              >
                {gData.name}
              </Card.Text>

              <Card.Text
                className="text-center"
                style={{
                  marginTop: "25px",
                  fontSize: "20px",
                  fontWeight: "bold",
                  color: "#000000",
                  padding: "8px",
                  backgroundColor: "#ffffff",
                  borderRadius: "12px",
                }}
              >
                链接信息
              </Card.Text>
              <ListGroup>
                {links.map((linkItem) => {
                  return (
                    <ListGroup.Item className="align-items-start justify-content-between">
                      <div className="fw-normal" style={{ fontSize: "20px" }}>
                        {linkItem.name}
                      </div>
                      <div
                        className="fw-bold"
                        style={{ fontSize: "20px", marginTop: "5px" }}
                      >
                        {linkItem.url}
                      </div>
                      <div style={{ marginTop: "25px" }}>
                        <Card.Link
                          style={{
                            fontSize: "15px",
                            fontWeight: "bold",
                            color: "black",
                          }}
                          onClick={() => {
                            const index = links.indexOf(linkItem);
                            setModifyId(index);
                            handleShow();
                          }}
                        >
                          修改
                        </Card.Link>
                        <Card.Link
                          style={{
                            fontSize: "15px",
                            fontWeight: "bold",
                            color: "red",
                          }}
                          onClick={() => {
                            //delete
                            const index = links.indexOf(linkItem);
                            if (index > -1) {
                              links.splice(index, 1);
                              setLinks(links);
                              setError("已删除链接" + index);
                            } else {
                              setError("无法删除");
                            }
                          }}
                        >
                          删除
                        </Card.Link>
                      </div>
                    </ListGroup.Item>
                  );
                })}
              </ListGroup>
              <Button
                className="w-100 mt3"
                style={{
                  alignItems: "center",
                  justifyContent: "space-between",
                  backgroundColor: "black",
                  borderRadius: "25px",
                  borderColor: "#ffffff",
                  borderWidth: "3px",
                  fontSize: "15px",
                  fontWeight: "bold",
                  height: "50px",
                  marginTop: "15px",
                  marginBottom: "5px",
                }}
                onClick={() => {
                  handleShow();
                }}
              >
                增加链接
              </Button>

              <Button
                className="w-100 mt3"
                style={{
                  alignItems: "center",
                  justifyContent: "space-between",
                  backgroundColor: "#F57828",
                  borderRadius: "25px",
                  borderColor: "#ffffff",
                  borderWidth: "3px",
                  fontSize: "15px",
                  fontWeight: "bold",
                  height: "50px",
                  marginTop: "15px",
                  marginBottom: "5px",
                }}
                onClick={() => {
                  const updateDa = { contacts: links };
                  fires
                    .collection("groups")
                    .doc(gData.id)
                    .update(updateDa)
                    .then((error) => {
                      if (error != null) {
                        setError("无法保存");
                      } else {
                        routeToHome();
                      }
                    });
                }}
              >
                保存
              </Button>
            </Card.Body>
          </Card>

          <Modal
            show={show}
            onHide={() => {
              setModifyId(-1);
              handleClose();
            }}
          >
            <Modal.Header closeButton>
              <Modal.Title>
                {modifyId === -1 ? "增加链接" : "修改链接"}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>链接名称</Form.Label>
                  <Form.Control
                    type="textarea"
                    placeholder="请输入链接名称"
                    ref={newLinkTitleRef}
                    defaultValue={modifyId !== -1 ? links[modifyId].name : ""}
                    autoFocus
                  />
                </Form.Group>
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlTextarea1"
                >
                  <Form.Label>链接</Form.Label>
                  <Form.Control
                    as="textarea"
                    ref={newLinkURLRef}
                    defaultValue={modifyId !== -1 ? links[modifyId].url : ""}
                    placeholder="https://"
                    rows={3}
                  />
                </Form.Group>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => {
                  navigator.clipboard.readText().then((text) => {
                    newLinkURLRef.current.value = text;
                  });
                }}
              >
                粘贴
              </Button>
              <Button
                variant="secondary"
                onClick={() => {
                  setModifyId(-1);
                  handleClose();
                }}
              >
                关闭
              </Button>
              <Button
                variant="primary"
                onClick={() => {
                  if (modifyId === -1) {
                    links.push({
                      name: newLinkTitleRef.current.value,
                      url: newLinkURLRef.current.value,
                      type: "url",
                    });
                  } else {
                    links[modifyId] = {
                      name: newLinkTitleRef.current.value,
                      url: newLinkURLRef.current.value,
                      type: "url",
                    };
                  }
                  setModifyId(-1);
                  setLinks(links);
                  setShow(false);
                }}
              >
                保存
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </Container>
    </>
  );
}
